import { render, staticRenderFns } from "./UcContractClientCard.yaml?vue&type=template&id=382f5103&component"
import script from "./UcContractClientCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractClientCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports